'use client'

import React, {createContext, useReducer} from 'react'

type ModalState = {isOpen: boolean}
type State = Record<string, ModalState>

const InitialState = {business_cabinet: {isOpen: false}} as State

export const ModalsContext = createContext<{
  state: State
  dispatch: React.Dispatch<Action>
}>({
  state: InitialState,
  dispatch: () => null,
})

type Action = {
  type: 'setOpen' | 'setClose'
  payload: string // id модалки
}

export const reducer = (state: State, action: Action) => {
  switch (action.type) {
    case 'setOpen':
      return Object.assign({}, state, {
        [action.payload]: {isOpen: true},
      })
    case 'setClose':
      return Object.assign({}, state, {
        [action.payload]: {isOpen: false},
      })
    default:
      return state
  }
}

export const ModalsProvider = ({children}: React.PropsWithChildren<{}>) => {
  const [state, dispatch] = useReducer(reducer, InitialState)

  return <ModalsContext.Provider value={{state, dispatch}}>{children}</ModalsContext.Provider>
}
